import React, { createContext, useState, useContext, useEffect } from "react";
import { userServicer } from "../Commen_Services/user.services";
import customToast from "../Common_Component/Toast/CustomToast";
import { useNavigate } from "react-router-dom";

interface AuthContextType {
    isAuthenticated: boolean;
    login: (inputs: any) => Promise<boolean>;
    logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const navigate = useNavigate();

useEffect(() => {
    const isAuthorizeData = localStorage.getItem('isAuthorized');
    if (isAuthorizeData !== null) {
        setIsAuthenticated(JSON.parse(isAuthorizeData).isAuthorized);
    } else {
        setIsAuthenticated(false);
    }
}, []);


    const login = async (inputs: any): Promise<boolean> => {
    try {
        const user = await userServicer.login(inputs);
        if (user.statusCode === 200) {
            if (user.status === true) {
                localStorage.setItem('user', JSON.stringify(user.data));
                localStorage.setItem('isAuthorized', JSON.stringify({ "isAuthorized": true }));
                setIsAuthenticated(true);
                return true;
            } else {
                customToast.error(user.message);
                return false;
            }
        } else {
            customToast.error("Something went Wrong");
            return false;
        }
    } catch (error) {
        customToast.error("Login failed");
        return false;
    }
};


    const logout = () => {
        localStorage.setItem('isAuthorized', JSON.stringify({"isAuthorized" : false}));
        navigate("/");
        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) throw new Error("useAuth must be used within AuthProvider");
    return context;
};
